module.exports = __webpack_public_path__ + "img/PR6.41c0a05c.gif";